"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.addBasketOffer = void 0;
var AddBasketOffer = _interopRequireWildcard(require("@ori-events/add-basket-offer"));
var AddBasketOfferFailed = _interopRequireWildcard(require("@ori-events/add-basket-offer-failed"));
var BasketUpdated = _interopRequireWildcard(require("@ori-events/basket-updated"));
var _analyticsData = require("@ori/analytics-data");
function _interopRequireWildcard(e, t) {
    if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap();
    return (_interopRequireWildcard = function(e, t) {
        if (!t && e && e.__esModule) return e;
        var o, i, f = {
            __proto__: null,
            default: e
        };
        if (null === e || "object" != typeof e && "function" != typeof e) return f;
        if (o = t ? n : r) {
            if (o.has(e)) return o.get(e);
            o.set(e, f);
        }
        for(const t in e)"default" !== t && ({}).hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]);
        return f;
    })(e, t);
}
/* eslint-disable @typescript-eslint/no-use-before-define -- don't want to change existing logic ATM */ const addBasketOffer = async (offerId, selectedItems)=>new Promise((resolve)=>{
        const removeListeners = ()=>{
            window.removeEventListener(BasketUpdated.Name, handleResolve);
            window.removeEventListener(AddBasketOfferFailed.Name, handleResolve);
        };
        const handleResolve = (event)=>{
            removeListeners();
            resolve(event.detail);
        };
        window.addEventListener(BasketUpdated.Name, handleResolve);
        window.addEventListener(AddBasketOfferFailed.Name, handleResolve);
        var _selectedItems_map;
        const items = (_selectedItems_map = selectedItems === null || selectedItems === void 0 ? void 0 : selectedItems.map((item)=>({
                ...item,
                quantity: item.selectedQuantity
            }))) !== null && _selectedItems_map !== void 0 ? _selectedItems_map : undefined;
        const customEvent = new CustomEvent(AddBasketOffer.Name, {
            detail: {
                items,
                offerId,
                placement: _analyticsData.Placement.OfferHints
            }
        });
        window.dispatchEvent(customEvent);
    });
exports.addBasketOffer = addBasketOffer;
